var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerClassName},[_c('p',{staticClass:"text-sm text-gray-600"},[_vm._v("\n        "+_vm._s(_vm.label)+"\n    ")]),_vm._v(" "),_vm._t("default",function(){return [(_vm.text)?_c('p',{staticClass:"text-gray-900"},[_vm._v("\n            "+_vm._s(_vm.text)+"\n        ")]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }